<ng-container *ngIf="callData">
  <div class="campaign-info" *ngIf="isCampaign">
    <h3 class="campaign-info-header">
      {{ campaignName }}
    </h3>
    <div class="cancel-campaign">
      <button id="cancel-campaign-item" class="action-button bg-warn btn-blockphone" color="warn" mat-stroked-button ng-reflect-color="warn" (click)="cancelCampaignItem()" title="{{ 'public.cancel'|translate }}">
        <span class="mat-button-wrapper">
          <mat-icon class="icon-phone mat-icon-no-color">
            phone
            <i class="fa fa-slash"></i>
          </mat-icon>
        </span>
      </button>
    </div>
    <div *ngIf="callDetails?.company" class="campaign-info-row">
      <div class="info-label">{{ 'enterprise_contact.content.company' | translate }}:</div><div class="info-value">{{ callDetails?.company }}</div>
    </div>
    <div *ngIf="callDetails?.custom1" class="campaign-info-row">
      <div class="info-label">{{ 'enterprise_contact.content.custom1' | translate }}:</div><div class="info-value">{{ callDetails?.custom1 }}</div>
    </div>
    <div *ngIf="callDetails?.custom2" class="campaign-info-row">
      <div class="info-label">{{ 'enterprise_contact.content.custom2' | translate }}:</div><div class="info-value">{{ callDetails?.custom2 }}</div>
    </div>
    <div *ngIf="callDetails?.custom3" class="campaign-info-row">
      <div class="info-label">{{ 'enterprise_contact.content.custom3' | translate }}:</div><div class="info-value">{{ callDetails?.custom3 }}</div>
    </div>
  </div>
  <div class="task-info" *ngIf="isTask">
    <div class="call-detail" *ngIf="callDetails?.description">{{ callDetails?.description }}</div>
  </div>
</ng-container>
